import { useId } from "react";
import type { ReactElement } from "react";
import { Knopf, Menue } from "@kundeninfo/ui/me-design";
import { OBJEKT_TEXT } from "./objektTexte.js";

export type ObjektMenueEintrag = { wert: string; text: string; gefaehrlich?: boolean };

export type ObjektMenueProps = {
  /** Zugänglicher Name des „⋯“ (etwa „Aktionen zu Liefervertrag Strom Nord“). */
  name: string;
  eintraege: readonly ObjektMenueEintrag[];
  /** Die Wahl; Bestätigungen gefährlicher Einträge stellt der Aufrufer (gestapelt, wie heute). */
  onWahl: (wert: string) => void;
};

/** „⋯“ des Objekts (Anatomie Teil 15): `Knopf` + `Menue` nach dem Muster der Liquiditätsleiste; ohne Einträge nichts. */
export function ObjektMenue(p: ObjektMenueProps): ReactElement | null {
  const ausloeser = useId();
  if (p.eintraege.length === 0) return null;
  return (
    <>
      <Knopf id={ausloeser} art="leise" kompakt aria-label={p.name}>{OBJEKT_TEXT.menue}</Knopf>
      <Menue fuer={ausloeser} onGewaehlt={(d) => p.onWahl(d.wert)}>
        {p.eintraege.map((e) => (
          <option key={e.wert} value={e.wert} {...(e.gefaehrlich === true ? { "data-art": "gefahr" } : {})}>{e.text}</option>
        ))}
      </Menue>
    </>
  );
}
